import { WindowCommand } from './window-command';

export class DownloadFileCommand extends WindowCommand {
  private downloadUrl: string;
  private fileName: string;
  private fileId: string;

  public constructor(fileId: string, fileName: string, downloadUrl: string) {
    super('download-file');
    this.fileId = fileId;
    this.fileName = fileName;
    this.downloadUrl = downloadUrl;
  }

  public get data() {
    return {
      fileId: this.fileId,
      fileName: this.fileName,
      downloadUrl: this.downloadUrl
    };
  }
}
